import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import {
  SendEmailToCompanyTaskDefinitionId,
  SendEmailToContactTaskDefinitionId,
  SendEmailToUserTaskDefinitionId,
} from '../../../component-loader/constants';

const NodeTitleFallback: { [key: string]: string } = {
  [SendEmailToUserTaskDefinitionId]: 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.SEND_HTML_EMAIL_TO_USER',
  [SendEmailToContactTaskDefinitionId]: 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.SEND_HTML_EMAIL_TO_CONTACT',
  [SendEmailToCompanyTaskDefinitionId]: 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.SEND_HTML_EMAIL_TO_COMPANY',
};

const ActivityTitle: { [key: string]: string } = {
  [SendEmailToUserTaskDefinitionId]: 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.ACTIVITY.TITLE',
  [SendEmailToContactTaskDefinitionId]: 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.ACTIVITY.TITLE_CONTACT',
  [SendEmailToCompanyTaskDefinitionId]: 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.ACTIVITY.TITLE_COMPANY',
};

@Injectable({
  providedIn: 'root',
})
export class SendHtmlEmailToUserService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    if (activity?.error) {
      return this.tableEntry(
        this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.ACTIVITY.FAILED'),
        this.emptyBody(),
      );
    }
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};
    let activityDetail = this.emptyBody();
    if (activity?.workflowStep?.taskDefinitionId === SendEmailToCompanyTaskDefinitionId) {
      activityDetail = this.translateService.stream(
        'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.ACTIVITY.SUBTITLE_COMPANY',
        { count: (activityData?.contact_ids || []).length },
      );
    }

    return this.tableEntry(
      this.translateService.stream(ActivityTitle[activity.workflowStep.taskDefinitionId]),
      activityDetail,
    );
  }

  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    const displayText = JSON.parse(step?.data)?.template_name
      ? this.translateService.stream('AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.ACTION.TITLE_WITH_TEMPLATE', {
          templateName: JSON.parse(step?.data)?.template_name,
        })
      : this.translateService.stream(NodeTitleFallback[step.taskDefinitionId]);

    return this.nodeDisplayData(displayText, this.noValidationErrorsDetected());
  }
}
